import React from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import CustomTable from "../../components/Common/CustomTable";
import useApi from "../../Hooks/useApi";
import {
  deleteDistributor,
  getDistributorList,
  updateDistributorStatus,
} from "../../helpers/API";
import useFilter from "../../Hooks/useFilter";
import { handleDelete, handleStatusChange } from "../../helpers/CommonAPICall";

const List = ({ t }) => {
  const [filters, setFilters] = useFilter({});
  const [data, setData] = useApi({
    callback: getDistributorList,
    payload: filters,
    dependencies: [filters],
  });

  const Navigate = useNavigate();

  const columns = [
    {
      name: t("distributor.list.columns.companyName"),
      selector: (row) => row.companyName,
      sortable: true,
      sortField: "companyName",
      grow: 3,
    },
    {
      name: t("distributor.list.columns.gstNumber"),
      selector: (row) => row.gstNumber,
      grow: 2,
    },
    {
      name: t("distributor.list.columns.panCardNumber"),
      selector: (row) => row.panCard,
      grow: 2,
    },
    {
      name: t("distributor.list.columns.numberOfBankAc"),
      selector: (row) => row.numberOfBankAc,
      sortField: "numberOfBankAc",
      sortable: true,
    },
    {
      name: t("distributor.list.columns.numberOfSubDistributor"),
      selector: (row) => row.numberOfSubDistributor,
      sortable: true,
      sortField: "numberOfSubVendor",
    },
    {
      name: t("distributor.list.columns.status"),
      sortable: true,
      sortField: "isActive",
      isStatus: true,
      onClick: (data) => {
        handleStatusChange(
          data.id,
          { isActive: data.isActive },
          updateDistributorStatus,
          setData
        );
      },
    },
    {
      name: t("distributor.list.columns.createdDate"),
      dateField: "createdAt",
      sortable: true,
      sortField: "createdAt",
      dateFormat: "dd/MM/yyyy",
    },
    {
      name: t("distributor.list.columns.updatedDate"),
      dateField: "updatedAt",
      sortable: true,
      sortField: "updatedAt",
      dateFormat: "dd/MM/yyyy",
    },
    {
      name: t("distributor.list.columns.actions"),
      dropdownItems: [
        {
          label: t("distributor.list.actions.view"),
          icon: "ri-eye-fill",
          className: "",
          onClick: (data) => {
            Navigate(`/distributor/view/${data.id}`);
          },
        },
        {
          label: t("distributor.list.actions.edit"),
          icon: "ri-pencil-fill",
          className: "edit-item-btn",
          onClick: (data) => {
            Navigate(`/distributor/edit/${data.id}`);
          },
        },
        {
          label: t("distributor.list.actions.delete"),
          icon: "ri-delete-bin-fill",
          className: "remove-item-btn",
          onClick: (data) => {
            handleDelete(data.id, deleteDistributor, setData);
          },
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <CustomTable
            columns={columns}
            data={data}
            buttonAction={() => {
              Navigate("/distributor/add");
            }}
            onStatusChange={(data) => setFilters(data)}
            searchKeys={["companyName", "panCard", "gstNumber"]}
            searchPlaceholder={t("distributor.list.search.placeholder")}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default withTranslation()(List);
